// extracted by mini-css-extract-plugin
export var active = "SubmenuLink-module--active--a3852";
export var description = "SubmenuLink-module--description--c04f9";
export var langSwitcher = "SubmenuLink-module--langSwitcher--f81e8";
export var link = "SubmenuLink-module--link--b48e3";
export var wrapLink = "SubmenuLink-module--wrapLink--c0efc";